import { render, staticRenderFns } from "./BlacklistedChassisList.vue?vue&type=template&id=9d3140bc&scoped=true&"
import script from "./BlacklistedChassisList.vue?vue&type=script&lang=js&"
export * from "./BlacklistedChassisList.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistedChassisList.vue?vue&type=style&index=0&id=9d3140bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3140bc",
  null
  
)

export default component.exports